module.exports = __webpack_public_path__ + "static/img/engb4.77e4b4a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/eng/engb4.png
// module id = w/yW
// module chunks = 0